var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVendor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.52 22.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #06513d;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.84 7.28 19.82 22.34 .69 22.34 .68 7.26 2.23 7.13 2.24 16.5 18.28 16.5 18.28 7.16 19.84 7.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.18,15.82H5.33c.1-.99.81-1.64,1.76-1.78l1.83-.28c-.8-1.22-1.3-2.29-1.07-3.6.22-1.25,1.17-2.09,2.31-2.13,1.17-.04,2.18.72,2.48,1.96.31,1.33-.18,2.56-1.06,3.75l2.35.43c.67.12,1.21.95,1.26,1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.79,0l-.48,5.34c-.08.87-.83,1.39-1.59,1.3-.82-.09-1.45-.8-1.29-1.72L4.28.03l2.51-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.97,6.63c-.83.18-1.69-.34-1.77-1.28L13.74,0l2.5.03.84,4.81c.16.93-.38,1.62-1.11,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.95,4.96c0,1.01-.56,1.63-1.44,1.7-.61.05-1.58-.56-1.51-1.41L7.42.01h2.5s.02,4.95.02,4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.16,6.65c-.76.05-1.58-.51-1.58-1.39V.02s2.51,0,2.51,0l.42,5.15c.07.89-.73,1.45-1.35,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.62.06l-.94,5.41c-.16.91-.99,1.35-1.74,1.11C.12,6.34-.19,5.52.12,4.65L1.67.27C2.22,0,3.04-.04,3.62.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.58,6.6c-.74.22-1.59-.22-1.73-1.04l-.96-5.56,1.91.13,1.63,4.62c.3.85-.14,1.64-.85,1.85Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendor);
export default __webpack_public_path__ + "static/media/Vendor.cc0192cd2e58c81f31655a274699685e.svg";
export { ForwardRef as ReactComponent };